// import { VRMHumanBoneName, VRMExpressionPresetName } from '@pixiv/three-vrm'

const bones = [
  {
    name: 'Head',
    label: '頭'
  },
  // {
  //   name: 'LeftEye',
  //   label: '左目'
  // },
  // {
  //   name: 'RightEye',
  //   label: '右目'
  // },
  {
    name: 'Neck',
    label: '首'
  },
  {
    name: 'Chest',
    label: '胸'
  },
  {
    name: 'Spine',
    label: '背骨'
  },
  // {
  //   name: 'UpperChest',
  //   label: '上胸(Unity該当なし)'
  // },
  {
    name: 'Hips',
    label: '尻'
  },

  // {
  //   name: 'Jaw',
  //   label: '顎'
  // },  
  {
    name: 'LeftUpperLeg',
    mirrorJoint: 'RightUpperLeg',
    label: '左太もも'
  },
  {
    name: 'LeftLowerLeg',
    mirrorJoint: 'RightLowerLeg',
    label: '左ひざ'
  },
  {
    name: 'LeftToes',
    mirrorJoint: 'RightToes',
    label: '左つま先'
  },
  {
    name: 'LeftFoot',
    mirrorJoint: 'RightFoot',
    label: '左足'
  },

  {
    name: 'RightUpperLeg',
    mirrorJoint: 'LeftUpperLeg',
    label: '右太もも'
  },
  {
    name: 'RightLowerLeg',
    mirrorJoint: 'LeftLowerLeg',
    label: '右ひざ'
  },
  {
    name: 'RightFoot',
    mirrorJoint: 'LeftFoot',
    label: '右足'
  },
  {
    name: 'RightToes',
    mirrorJoint: 'LeftToes',
    label: '右つま先'
  },

  {
    name: 'LeftShoulder',
    mirrorJoint: 'RightShoulder',
    label: '左肩'
  },
  {
    name: 'LeftUpperArm',
    mirrorJoint: 'RightUpperArm',
    label: '左上腕'
  },
  {
    name: 'LeftLowerArm',
    mirrorJoint: 'RightLowerArm',
    label: '左ひじ'
  },
  {
    name: 'LeftHand',
    mirrorJoint: 'RightHand',
    label: '左手'
  },

  {
    name: 'RightShoulder',
    mirrorJoint: 'LeftShoulder',
    label: '右肩'
  },
  {
    name: 'RightUpperArm',
    mirrorJoint: 'LeftUpperArm',
    label: '右上腕'
  },
  {
    name: 'RightLowerArm',
    mirrorJoint: 'LeftLowerArm',
    label: '右ひじ'
  },
  {
    name: 'RightHand',
    mirrorJoint: 'LeftHand',
    label: '右手'
  }
]

const leftHandBones = [
  {
    name: 'LeftIndexDistal',
    mirrorJoint: 'RightIndexDistal',
    label: '左人差し指第三指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.027 }
  },
  {
    name: 'LeftIndexIntermediate',
    mirrorJoint: 'RightIndexIntermediate',
    label: '左人差し指第二指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.014 }
  },
  {
    name: 'LeftIndexProximal',
    mirrorJoint: 'RightIndexProximal',
    label: '左人差し指第一指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.32 }
  },
  {
    name: 'LeftMiddleDistal',
    mirrorJoint: 'RightMiddleDistal',
    label: '左中指第三指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.4 }
  },
  {
    name: 'LeftMiddleIntermediate',
    mirrorJoint: 'RightMiddleIntermediate',
    label: '左中指第二指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.4 }
  },
  {
    name: 'LeftMiddleProximal',
    mirrorJoint: 'RightMiddleProximal',
    label: '左中指第一指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.4 }
  },
  {
    name: 'LeftRingDistal',
    mirrorJoint: 'RightRingDistal',
    label: '左薬指第三指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.4 }
  },
  {
    name: 'LeftRingIntermediate',
    mirrorJoint: 'RightRingIntermediate',
    label: '左薬指第二指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.4 }
  },
  {
    name: 'LeftRingProximal',
    mirrorJoint: 'RightRingProximal',
    label: '左薬指第一指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.4 }
  },
  {
    name: 'LeftLittleDistal',
    mirrorJoint: 'RightLittleDistal',
    label: '左小指第三指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.4 }
  },
  {
    name: 'LeftLittleIntermediate',
    mirrorJoint: 'RightLittleIntermediate',
    label: '左小指第二指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.4 }
  },
  {
    name: 'LeftLittleProximal',
    mirrorJoint: 'RightLittleProximal',
    label: '左小指第一指骨',    
    axisForGrasp: { x: 0, y: 0, z: 1.4 }
  },  


  // {
  //   name: 'LeftThumbDistal',
  //   mirrorJoint: 'RightThumbDistal',
  //   label: '左親指第三指骨',    
  //   axisForGrasp: { x: 0.018, y: 0.682, z: -0.0343 }
  // },
  // {
  //   name: 'LeftThumbMetacarpal',
  //   mirrorJoint: 'RightThumbMetacarpal',
  //   label: '左親指第二指骨',    
  //   axisForGrasp: { x: 0, y: 0, z: 0 }
  //   // axisForGrasp: { x: 0, y: 0.595, z: -0.017 }
  // },
  // {
  //   name: 'LeftThumbProximal',
  //   mirrorJoint: 'RightThumbProximal',
  //   label: '左親指第一指骨',    
  //   axisForGrasp: { x: -0.32, y: 0.722, z: 0.147 }
  // }
  {
    name: 'LeftThumbDistal',
    mirrorJoint: 'RightThumbDistal',
    label: '左親指第三指骨',    
    axisForGrasp: { x: 0.018, y: 0.682, z: -0.0343 }
  },
  {
    // name: 'LeftThumbMetacarpal',
    // mirrorJoint: 'RightThumbMetacarpal',
    name: 'LeftThumbProximal',
    mirrorJoint: 'RightThumbProximal',
    label: '左親指第二指骨',    
    axisForGrasp: { x: 0, y: 0, z: 0 }
    // axisForGrasp: { x: 0, y: 0.595, z: -0.017 }
  },
  {
    // name: 'LeftThumbProximal',
    // mirrorJoint: 'RightThumbProximal',
    name: 'LeftThumbMetacarpal',
    mirrorJoint: 'RightThumbMetacarpal',
    label: '左親指第一指骨',    
    axisForGrasp: { x: -0.32, y: 0.722, z: 0.147 }
  }
]

const rightHandBones = [
  {
    name: 'RightIndexDistal',
    mirrorJoint: 'LeftIndexDistal',
    label: '右人差し指第三指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.027 }
  },
  {
    name: 'RightIndexIntermediate',
    mirrorJoint: 'LeftIndexIntermediate',
    label: '右人差し指第二指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.014 }
  },
  {
    name: 'RightIndexProximal',
    mirrorJoint: 'LeftIndexProximal',
    label: '右人差し指第一指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.32 }
  },
  {
    name: 'RightMiddleDistal',
    mirrorJoint: 'LeftMiddleDistal',
    label: '右中指第三指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.4 }
  },
  {
    name: 'RightMiddleIntermediate',
    mirrorJoint: 'LeftMiddleIntermediate',
    label: '右中指第二指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.4 }
  },
  {
    name: 'RightMiddleProximal',
    mirrorJoint: 'LeftMiddleProximal',
    label: '右中指第一指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.4 }
  },
  {
    name: 'RightRingDistal',
    mirrorJoint: 'LeftRingDistal',
    label: '右薬指第三指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.4 }
  },
  {
    name: 'RightRingIntermediate',
    mirrorJoint: 'LeftRingIntermediate',
    label: '右薬指第二指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.4 }
  },
  {
    name: 'RightRingProximal',
    mirrorJoint: 'LeftRingProximal',
    label: '右薬指第一指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.4 }
  },
  {
    name: 'RightLittleDistal',
    mirrorJoint: 'LeftLittleDistal',
    label: '右小指第三指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.4 }
  },
  {
    name: 'RightLittleIntermediate',
    mirrorJoint: 'LeftLittleIntermediate',
    label: '右小指第二指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.4 }
  },
  {
    name: 'RightLittleProximal',
    mirrorJoint: 'LeftLittleProximal',
    label: '右小指第一指骨',
    axisForGrasp: { x: 0, y: 0, z: -1.4 }
  },
  {
    name: 'RightThumbDistal',
    mirrorJoint: 'LeftThumbDistal',
    label: '右親指第三指骨',
    axisForGrasp: { x: -0.018, y: -0.682, z: 0.0343 }
  },
  {
    // name: 'RightThumbMetacarpal',
    // mirrorJoint: 'LeftThumbMetacarpal',
    name: 'RightThumbProximal',
    mirrorJoint: 'LeftThumbProximal',
    label: '右親指第二指骨',
    axisForGrasp: { x: 0, y: 0, z: 0 }
    // axisForGrasp: { x: 0, y: -0.595, z: 0.017 }
  },
  {
    // name: 'RightThumbProximal',
    // mirrorJoint: 'LeftThumbProximal',
    name: 'RightThumbMetacarpal',
    mirrorJoint: 'LeftThumbMetacarpal',
    label: '右親指第一指骨',
    axisForGrasp: { x: 0.32, y: -0.722, z: -0.147 }
  }
]

const eyesBones = [
  {
    name: 'LeftEye',
    label: '左目'
  },
  {
    name: 'RightEye',
    label: '右目'
  }
]

const blendShapes = [
  // {
  //   name: 'Neutral',
  //   nameV0: 'Neutral',
  //   label: 'Neutral'
  // },

  // Joy is removed
  // {
  //   name: 'Joy',
  //   nameV0: 'Joy',
  //   label: '喜'
  // },

  {
    name: 'Surprised',
    nameV0: 'Surprised',
    label: '驚'
  },
  {
    name: 'Angry',
    nameV0: 'Angry',
    label: '怒'
  },
  {
    name: 'Relaxed',
    nameV0: 'Joy',
    label: '安心'
  },
  {
    name: 'Happy',
    nameV0: 'Fun',
    label: '楽'
  },
  {
    name: 'Sad',
    nameV0: 'Sorrow',
    label: '哀'
  },

  {
    name: 'Aa',
    nameV0: 'A',
    label: '「あ」'
  },
  {
    name: 'Ih',
    nameV0: 'I',
    label: '「い」'
  },
  {
    name: 'Ou',
    nameV0: 'U',
    label: '「う」'
  },
  {
    name: 'Ee',
    nameV0: 'E',
    label: '「え」'
  },
  {
    name: 'Oh',
    nameV0: 'O',
    label: '「お」'
  },
  {
    name: 'Blink',
    nameV0: 'Blink',
    label: 'まばたき'
  },
  {
    name: 'BlinkLeft',
    nameV0: 'Blink_L',
    label: 'まばたき 左'
  },
  {
    name: 'BlinkRight',
    nameV0: 'Blink_R',
    label: 'まばたき 右'
  },

  // {
  //   nameV0: 'Lookdown',
  //   label: 'Lookdown'
  // },
  // {
  //   nameV0: 'Lookleft',
  //   label: 'Lookleft'
  // },
  // {
  //   nameV0: 'Lookright',
  //   label: 'Lookright'
  // },
  // {
  //   nameV0: 'Lookup',
  //   label: 'Lookup'
  // }
]

// const blendShapes = [
//   // {
//   //   name: 'Neutral',
//   //   label: 'Neutral'
//   // },

//   {
//     name: 'Joy',
//     label: '喜'
//   },
//   {
//     name: 'Angry',
//     label: '怒'
//   },
//   {
//     name: 'Sorrow',
//     label: '哀'
//   },
//   {
//     name: 'Fun',
//     label: '楽'
//   },
//   {
//     name: 'Surprised',
//     label: '驚'
//   },

//   // {
//   //   name: 'Unknown',
//   //   label: 'Unknown'
//   // },

//   {
//     name: 'A',
//     label: '「あ」'
//   },
//   {
//     name: 'I',
//     label: '「い」'
//   },
//   {
//     name: 'U',
//     label: '「う」'
//   },
//   {
//     name: 'E',
//     label: '「え」'
//   },
//   {
//     name: 'O',
//     label: '「お」'
//   },
//   {
//     name: 'Blink',
//     label: 'まばたき'
//   },
//   {
//     name: 'Blink_L',
//     label: 'まばたき 左'
//   },
//   {
//     name: 'Blink_R',
//     label: 'まばたき 右'
//   },

//   // {
//   //   name: 'Lookdown',
//   //   label: 'Lookdown'
//   // },
//   // {
//   //   name: 'Lookleft',
//   //   label: 'Lookleft'
//   // },
//   // {
//   //   name: 'Lookright',
//   //   label: 'Lookright'
//   // },
//   // {
//   //   name: 'Lookup',
//   //   label: 'Lookup'
//   // }
// ]

export { bones, leftHandBones, rightHandBones, eyesBones, blendShapes }